/**
 * Nom complet d'un projet : nom du projet + adresse de la propriété acquise.
 * Ex. : "Rénovation cuisine - 247 rue Notre-Dame"
 */

/**
 * @param {Object} project - Projet (name)
 * @param {Object} property - Propriété acquise (address, city)
 * @returns {string} Nom complet pour l'affichage
 */
export function getProjectDisplayName(project, property) {
  const name = project?.name?.trim() || 'Sans nom';
  if (!property) return name;
  const address = property?.address?.trim() || '';
  const city = property?.city?.trim() || '';
  const location = [address, city].filter(Boolean).join(', ') || 'Sans adresse';
  return `${name} - ${location}`;
}

export default { getProjectDisplayName };
